export default {"src":"/_next/static/media/mumbai.a2c0f874.svg","height":78,"width":132};